import React from 'react';
import PropTypes from 'prop-types';
import styles from './monitor.css';
import hp from './icon/hp.png';

const HpMonitor = ({categoryColor, label, value}) => (
    <div className={styles.themeMonitor}>
         <img src={hp} className={styles.themeMonitorIcon}/>
         <div className={styles.themeMonitorVbg}>
            <div className={styles.themeMonitorValue}>{value}</div>
         </div>
    </div>
);

HpMonitor.propTypes = {
    categoryColor: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ])
};

export default HpMonitor;
